import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43cfac48"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "mail-contacts",
  "aria-label": "私信会话"
}
const _hoisted_2 = { class: "mail-list-heading" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "最近联系", -1))
const _hoisted_4 = {
  key: 1,
  class: "mail-status",
  role: "status"
}
const _hoisted_5 = {
  key: 2,
  class: "mail-status"
}
const _hoisted_6 = { class: "mail-contact-scroll" }
const _hoisted_7 = ["aria-pressed", "onClick"]
const _hoisted_8 = { class: "mail-contact-copy" }
const _hoisted_9 = { class: "mail-contact-top" }
const _hoisted_10 = { class: "mail-contact-preview" }
const _hoisted_11 = {
  key: 0,
  class: "mail-unread"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mail-list-note" }, "有过来往的同学，会一直留在这里", -1))
const _hoisted_13 = {
  class: "mail-thread",
  "aria-label": "聊天内容"
}
const _hoisted_14 = {
  key: 0,
  class: "mail-welcome"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "每一件闲置，都能聊出新故事", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "选择一位同学，接着上次的话题聊", -1))
const _hoisted_17 = { class: "mail-thread-header" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "一对一私聊", -1))
const _hoisted_19 = {
  key: 0,
  class: "mail-status",
  role: "status"
}
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 1,
  class: "mail-empty"
}
const _hoisted_22 = {
  key: 2,
  class: "mail-empty"
}
const _hoisted_23 = ["onSubmit"]
const _hoisted_24 = { class: "mail-compose-actions" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enter 发送 · Shift + Enter 换行", -1))
const _hoisted_26 = {
  key: 0,
  class: "mail-emoji-picker"
}

import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch
} from "vue";
import { ElMessage } from "element-plus";
import EmojiPicker from "vue3-emoji-picker";
import "vue3-emoji-picker/css";
import usePrivateMessageStore from "@/store/modules/privateMessage";
import {
  addPrivateMessageUsingPost,
  listMyPrivateMessageVoByPageUsingPost
} from "@/api/privateMessageController";
import { newerMessageId } from "@/utils/privateMessageState";
import { GET_ROLE } from "@/utils/token";
import { listUserVoByPageUsingPost } from "@/api/userController";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const chat = usePrivateMessageStore();
// Preserve administrators' existing ability to start a chat from the user directory.
const isAdmin = GET_ROLE() === "admin";
const directory = ref<API.UserVO[]>([]);
const directoryId = ref("");
const directoryLoading = ref(false);
let directoryRevision = 0;
async function loadDirectory(userName: string) {
  const version = ++directoryRevision;
  directoryLoading.value = true;
  try {
    const result = (await listUserVoByPageUsingPost(
      { userRole: "user", userName, current: 1, pageSize: 50 },
      { silent: true }
    )) as unknown as API.BaseResponsePageUserVO_;
    if (version === directoryRevision) {
      if (result.code !== 200) throw new Error("暂时无法查找同学");
      directory.value = result.data?.records || [];
    }
  } catch {
    if (version === directoryRevision)
      ElMessage.error("暂时无法查找同学，请重试");
  } finally {
    if (version === directoryRevision) directoryLoading.value = false;
  }
}
function selectDirectoryContact(id: string) {
  const user = directory.value.find((item) => String(item.id) === id);
  if (user) chat.openContact({ ...user, id });
  directoryId.value = "";
}
const messages = ref<API.PrivateMessageVO[]>([]);
const total = ref(0);
const loading = ref(false);
const sending = computed(() => !!chat.sendingContacts[chat.activeId]);
const loadError = ref("");
const atBottom = ref(true);
const showEmoji = ref(false);
const scrollArea = ref<HTMLElement>();
let revision = 0;
let timer: ReturnType<typeof setInterval>;
const draft = computed({
  get: () => chat.drafts[chat.activeId] || "",
  set: (value: string) => {
    chat.drafts[chat.activeId] = value;
  }
});
function shortTime(value?: string, full = false) {
  if (!value) return "";
  const today = new Date();
  const date = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(today.getDate()).padStart(2, "0")}`;
  return value.startsWith(date)
    ? value.slice(11, 16)
    : value.slice(5, full ? 16 : 10);
}
function merge(rows: API.PrivateMessageVO[]) {
  messages.value = [
    ...new Map(
      [...messages.value, ...rows].map((m) => [String(m.id), m])
    ).values()
  ].sort((a, b) => (newerMessageId(String(a.id), String(b.id)) ? 1 : -1));
}
function markVisibleRead() {
  if (!atBottom.value || !chat.opened || document.visibilityState !== "visible")
    return;
  const last = [...messages.value]
    .reverse()
    .find((m) => String(m.recipientId) === chat.owner);
  if (last?.id) chat.markRead(chat.activeId, String(last.id));
}
function onScroll() {
  const area = scrollArea.value;
  atBottom.value =
    !!area && area.scrollHeight - area.scrollTop - area.clientHeight < 24;
  markVisibleRead();
}
async function scrollBottom() {
  await nextTick();
  const area = scrollArea.value;
  if (area) area.scrollTop = area.scrollHeight;
  atBottom.value = true;
  markVisibleRead();
}
async function fetchPage(contact: string, current: number) {
  const result = (await listMyPrivateMessageVoByPageUsingPost(
    {
      contactUserId: contact,
      current,
      pageSize: 50,
      sortField: "id",
      sortOrder: "desc"
    },
    { silent: true }
  )) as unknown as API.BaseResponsePagePrivateMessageVO_;
  if (result.code !== 200 || !result.data) throw new Error("无法读取聊天记录");
  return result.data;
}
async function loadLatest(forceBottom = false) {
  const contact = chat.activeId;
  if (!contact || loading.value) return;
  const version = revision;
  const wasBottom = atBottom.value;
  const anchor = messages.value[messages.value.length - 1]?.id;
  loading.value = true;
  try {
    const rows: API.PrivateMessageVO[] = [];
    let current = 1;
    let keepLoading = false;
    do {
      const page = await fetchPage(contact, current++);
      if (version !== revision) return;
      total.value = Number(page.total || 0);
      const batch = page.records || [];
      rows.push(...batch);
      keepLoading =
        !!anchor &&
        batch.length === 50 &&
        rows.length < total.value &&
        batch.every((m) => newerMessageId(String(m.id), String(anchor)));
    } while (keepLoading);
    merge(rows);
    loadError.value = "";
    if (wasBottom || forceBottom) await scrollBottom();
  } catch {
    if (version === revision) loadError.value = "聊天记录暂未同步，请稍后重试";
  } finally {
    if (version === revision) loading.value = false;
  }
}
async function loadOlder() {
  if (loading.value) return;
  const version = revision;
  const area = scrollArea.value;
  const height = area?.scrollHeight || 0;
  const top = area?.scrollTop || 0;
  loading.value = true;
  try {
    const page = await fetchPage(
      chat.activeId,
      Math.floor(messages.value.length / 50) + 1
    );
    if (version !== revision) return;
    total.value = Number(page.total || 0);
    merge(page.records || []);
    loadError.value = "";
    await nextTick();
    if (area) area.scrollTop = top + area.scrollHeight - height;
  } catch {
    if (version === revision) loadError.value = "更早的消息加载失败，请重试";
  } finally {
    if (version === revision) loading.value = false;
  }
}
async function sendMessage() {
  const contact = chat.activeId;
  const content = draft.value.trim();
  if (!contact || !content || sending.value) return;
  chat.sendingContacts[contact] = true;
  const session = chat.sessionVersion;
  try {
    const result = (await addPrivateMessageUsingPost(
      { recipientId: contact, content },
      { silent: true }
    )) as unknown as API.BaseResponseLong_;
    if (result.code !== 200)
      throw new Error(result.message || "发送失败，请重试");
    if (chat.sessionVersion !== session) return;
    if ((chat.drafts[contact] || "").trim() === content)
      chat.drafts[contact] = "";
    showEmoji.value = false;
    await chat.refresh();
    if (chat.activeId === contact) await loadLatest(true);
  } catch (error) {
    if (chat.sessionVersion === session)
      ElMessage.error(
        error instanceof Error ? error.message : "发送失败，请重试"
      );
  } finally {
    if (chat.sessionVersion === session) delete chat.sendingContacts[contact];
  }
}
function onKeydown(event: KeyboardEvent) {
  if (
    event.key === "Enter" &&
    !event.shiftKey &&
    !event.isComposing &&
    event.keyCode !== 229
  ) {
    event.preventDefault();
    void sendMessage();
  }
}
function insertEmoji(event: { i: string }) {
  if (draft.value.length + event.i.length <= 1024) draft.value += event.i;
}
function poll() {
  if (document.visibilityState === "visible" && chat.opened) void loadLatest();
}
watch(
  () => chat.activeId,
  () => {
    revision++;
    messages.value = [];
    total.value = 0;
    loading.value = false;
    loadError.value = "";
    atBottom.value = true;
    showEmoji.value = false;
    void loadLatest(true);
  },
  { immediate: true }
);
watch(() => chat.activeConversation?.lastMessageId, poll);
onMounted(() => {
  timer = setInterval(poll, 8000);
  document.addEventListener("visibilitychange", poll);
});
onBeforeUnmount(() => {
  revision++;
  directoryRevision++;
  clearInterval(timer);
  document.removeEventListener("visibilitychange", poll);
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_Message = _resolveComponent("Message")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Position = _resolveComponent("Position")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["private-mail", { 'has-contact': _unref(chat).activeId }])
  }, [
    _createElementVNode("aside", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("span", null, _toDisplayString(_unref(chat).conversations.length) + " 位同学", 1)
      ]),
      isAdmin
        ? (_openBlock(), _createBlock(_component_el_select, {
            key: 0,
            modelValue: directoryId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((directoryId).value = $event)),
            class: "mail-directory",
            filterable: "",
            remote: "",
            "remote-method": loadDirectory,
            loading: directoryLoading.value,
            placeholder: "查找同学，发起私聊",
            "aria-label": "查找同学",
            onVisibleChange: _cache[1] || (_cache[1] = (visible) => visible && loadDirectory('')),
            onChange: selectDirectoryContact
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(directory.value, (user) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: user.id,
                  label: user.userName || '对方用户',
                  value: String(user.id)
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "loading"]))
        : _createCommentVNode("", true),
      (_unref(chat).error)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _createTextVNode(_toDisplayString(_unref(chat).error) + " ", 1),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(chat).refresh()))
            }, "重试")
          ]))
        : (_unref(chat).loading && !_unref(chat).conversations.length)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, " 正在整理来信… "))
          : (!_unref(chat).conversations.length)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 3,
                description: "暂无来信，去商品页联系同学吧",
                "image-size": 80
              }))
            : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chat).conversations, (contact) => {
          return (_openBlock(), _createElementBlock("button", {
            key: contact.contactUserId,
            class: _normalizeClass(["mail-contact", { selected: contact.contactUserId === _unref(chat).activeId }]),
            "aria-pressed": contact.contactUserId === _unref(chat).activeId,
            onClick: ($event: any) => (_unref(chat).activeId = contact.contactUserId)
          }, [
            _createVNode(_component_el_avatar, {
              size: 38,
              src: contact.userAvatar
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(contact.userName.slice(0, 1)), 1)
              ]),
              _: 2
            }, 1032, ["src"]),
            _createElementVNode("span", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("strong", null, _toDisplayString(contact.userName), 1),
                _createElementVNode("time", null, _toDisplayString(shortTime(contact.lastMessageTime)), 1)
              ]),
              _createElementVNode("span", _hoisted_10, _toDisplayString(contact.lastMessageContent || "打个招呼，开始聊天"), 1),
              (_unref(chat).isUnread(contact))
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "新消息"))
                : _createCommentVNode("", true)
            ])
          ], 10, _hoisted_7))
        }), 128))
      ]),
      _hoisted_12
    ]),
    _createElementVNode("section", _hoisted_13, [
      (!_unref(chat).activeConversation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_el_icon, { size: 38 }, {
              default: _withCtx(() => [
                _createVNode(_component_Message)
              ]),
              _: 1
            }),
            _hoisted_15,
            _hoisted_16
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("header", _hoisted_17, [
              _createElementVNode("button", {
                class: "mail-back",
                "aria-label": "返回会话列表",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(chat).activeId = ''))
              }, [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ArrowLeft)
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_avatar, {
                size: 36,
                src: _unref(chat).activeConversation.userAvatar
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(chat).activeConversation.userName.slice(0, 1)), 1)
                ]),
                _: 1
              }, 8, ["src"]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, _toDisplayString(_unref(chat).activeConversation.userName), 1),
                _hoisted_18
              ])
            ]),
            (loadError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                  _createTextVNode(_toDisplayString(loadError.value) + " ", 1),
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (loadLatest()))
                  }, "重试")
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              ref_key: "scrollArea",
              ref: scrollArea,
              class: "mail-messages",
              onScroll: onScroll
            }, [
              (messages.value.length < total.value)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "mail-history",
                    disabled: loading.value,
                    onClick: loadOlder
                  }, _toDisplayString(loading.value ? "加载中…" : "查看更早的消息"), 9, _hoisted_20))
                : _createCommentVNode("", true),
              (loading.value && !messages.value.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_21, " 正在读取聊天记录… "))
                : (!messages.value.length && !loadError.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, " 还没有消息，和同学打个招呼吧 "))
                  : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (message) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: message.id,
                  class: _normalizeClass(["mail-message", { sent: String(message.senderId) === _unref(chat).owner }])
                }, [
                  _createElementVNode("p", null, _toDisplayString(message.content), 1),
                  _createElementVNode("time", null, _toDisplayString(shortTime(message.createTime, true)), 1)
                ], 2))
              }), 128))
            ], 544),
            (
            !atBottom.value &&
            _unref(chat).activeConversation &&
            _unref(chat).isUnread(_unref(chat).activeConversation)
          )
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "mail-new",
                  onClick: scrollBottom
                }, " 有新消息，点击查看 ↓ "))
              : _createCommentVNode("", true),
            _createElementVNode("form", {
              class: "mail-compose",
              onSubmit: _withModifiers(sendMessage, ["prevent"])
            }, [
              _createVNode(_component_el_input, {
                modelValue: draft.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((draft).value = $event)),
                type: "textarea",
                rows: 3,
                maxlength: "1024",
                resize: "none",
                placeholder: "和同学说点什么…",
                "aria-label": "私信内容",
                onKeydown: onKeydown
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode(_component_el_button, {
                  class: "mail-emoji",
                  "aria-label": "插入表情",
                  "aria-expanded": showEmoji.value,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (showEmoji.value = !showEmoji.value))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("表情")
                  ]),
                  _: 1
                }, 8, ["aria-expanded"]),
                _createVNode(_component_el_button, {
                  "native-type": "submit",
                  type: "primary",
                  loading: sending.value,
                  disabled: !draft.value.trim() || sending.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("发送 "),
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Position)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              (showEmoji.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createVNode(_unref(EmojiPicker), {
                      native: true,
                      onSelect: insertEmoji
                    })
                  ]))
                : _createCommentVNode("", true)
            ], 40, _hoisted_23)
          ], 64))
    ])
  ], 2))
}
}

})